import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Observable } from 'rxjs/internal/Observable';
import { map } from 'rxjs/operators';

@Component({
    selector: 'app-shipment-screen',
    template: ` <rt-trip-error [ormId]="id$ | async"></rt-trip-error>`,
})
export class InterfaceValidationSingleScreenComponent implements OnInit {
    id$: Observable<number>;

    constructor(private route: ActivatedRoute) {}

    ngOnInit(): void {
        this.id$ = this.route.params.pipe(map((params) => +params['ormId'] || 0));
    }
}
